import LivedigitalSDKError from './LivedigitalSDKError';

class TooManyRequestsError extends LivedigitalSDKError {
  static readonly DEFAULT_MESSAGE = 'Too many requests';

  constructor(msg?: string, errorCode?: string, meta?: Record<string, unknown>) {
    super(msg ?? TooManyRequestsError.DEFAULT_MESSAGE, errorCode ?? 'too_many_requests', meta);
  }
}

export default TooManyRequestsError;
